import { Avatar, Divider, Icon, Input, ListItemIcon, ListItemText, Menu, MenuItem, Paper, TableRow, withStyles } from '@material-ui/core';
import XAPPButton from "app/Core/Components/Button/XAPPButton";
import MensagemAgendamento from "app/Core/Components/Mensagem/MensagemAgendamento";
import TagFormulario from "app/Core/Components/TagFormulario/TagFormulario";
import XAPPComponent from 'app/Core/Components/XAPPComponent/XAPPComponent';
import { getAcronimo } from "app/Core/Helpers";
import DisponibilizarButton from "app/CRM/AgendamentoEdicao/Components/DisponibilizarButton";
import EmpresaPessoaProntuarioApp from "app/ERP/EmpresaPessoaProntuario/EmpresaPessoaProntuarioApp";
import clsx from 'clsx';
import MobileDetect from 'mobile-detect';
import _ from 'lodash';
import React from 'react';
import { IoMdCalendar } from "react-icons/io";
import { FuseAnimate, FuseAnimateGroup } from "@fuse";
import { MdLabel } from "react-icons/md";

const md = new MobileDetect(window.navigator.userAgent);


const styles = theme => ({
    paper: {
        padding: '2px 4px',
        display: 'flex',
        alignItems: 'center',
        borderRadius: 8,
    },
});

class ToolbarFiltro extends XAPPComponent {

    state = {
        texto: "",
        tags: [],
        menuEl: null
    }

    componentDidUpdate(prevProps) {
        if (!_.isEqual(prevProps.updated, this.props.updated)) {
            this.setState(_.set({ ...this.state, "texto": "", "tags": [] }));
        }
    }

    handleChange = (event) => {
        this.setState(_.set({ ...this.state }, event.target.name, event.target.type === "checkbox" ? event.target.checked : event.target.value));
    };

    handleChangeMenu = (_AValue) => {
        this.setState(_.set({ ...this.state }, "menuEl", _AValue));
    }

    setTag = (_AValue) => {
        let ATags = [...this.state.tags];
        if (ATags.includes(_AValue)) {
            ATags = _.filter(ATags, x => x !== _AValue);
        }
        else {
            ATags.push(_AValue);
        }

        this.setState(_.set({ ...this.state }, "tags", ATags));
    }

    isSelected = (_AIDTag) => {
        return (
            this.state.tags.includes(_AIDTag)
        );
    }

    render() {
        const { setMultiFiltro, xappRouteParams, theme, classes, onClick, intervaloAtendimento, Tags = [] } = this.props;
        const { texto = "", tags = [], menuEl = null } = this.state;
        return (
            <div className="flex w-full items-center justify-center">
                <Paper component="div" className={clsx(classes.paper, "w-2/3")} elevation={1}>
                    <Input
                        placeholder="Pesquisar"
                        className="flex w-full pl-12 py-4"
                        disableUnderline
                        fullWidth
                        name="texto"
                        value={texto}
                        type='text'
                        autoComplete="off"
                        inputProps={{
                            'aria-label': 'Filtar'
                        }}
                        onChange={this.handleChange}
                    />
                    {(tags.length > 0 || texto.length > 0) &&
                        <XAPPButton
                            tooltip={{ "title": "Tags", "placement": "top" }}
                            type="Icon"
                            className=""
                            onClick={() => {
                                this.setState(_.set({ ...this.state, "texto": "", "tags": [] }));
                                setMultiFiltro("", []);
                            }}
                            icon={"close"}
                        />
                    }
                    {Tags.length > 0 &&
                        <XAPPButton
                            tooltip={{ "title": "Tags", "placement": "top" }}
                            type="Icon"
                            className=""
                            onClick={ev => this.handleChangeMenu(ev.currentTarget)}
                            icon={"filtro"}
                            badge={tags.length}
                        />
                    }
                    <XAPPButton
                        tooltip={{ "title": "Pesquisar", "placement": "top" }}
                        type="Icon"
                        className=""
                        onClick={() => setMultiFiltro(texto, tags)}
                        icon={"search"}
                    />
                </Paper>
                <Menu
                    id="label-menu"
                    anchorEl={menuEl}
                    open={Boolean(menuEl)}
                    onClose={() => this.handleChangeMenu(null)}
                >
                    {Tags.map((tag) => (
                        <MenuItem
                            onClick={() => { this.setTag(tag.idtag) }}
                            key={"MenuItem_" + tag.idtag}
                        >
                            <ListItemIcon>
                                <Icon className="mr-0" color="action">
                                    {this.isSelected(tag.idtag) ? 'check_box' : 'check_box_outline_blank'}
                                </Icon>
                            </ListItemIcon>
                            <ListItemIcon>
                                <MdLabel className="mr-0" color="action" />
                            </ListItemIcon>
                            <ListItemText primary={tag.nome} disableTypography={true} />
                        </MenuItem>
                    ))}
                </Menu>
            </div>
        );
    }
}


export default withStyles(styles, { withTheme: true })(ToolbarFiltro);
